import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import * as S from './styles'

export interface Under24HourWarningModalProps {
  open: boolean;
  handleClose: () => void;
  action: 'cancelar' | 'remarcar';
}

export const Under24HourWarningModal: React.FC<Under24HourWarningModalProps> = ({
  open,
  handleClose,
  action
}) => {

  if (!open) return null

  return (
    <ModalGeneric
      modalTitle=''
      hasButton
      onCloseModal={handleClose}
      btnOnClick={handleClose}
      btnText='ENTENDI'
    >
      <S.Container>
        <Typography center color="danger" variant='header4'>
          Desculpe, não é possível {action} a reserva com menos de 24 horas do horário da consulta.
        </Typography>

        <S.TextWrapper>
          <Typography variant="content2" center>Esta regra existe para garantir o compromisso entre paciente e profissional quanto a programação de agendas.</Typography>
          <Typography variant="content2" center>Procure {action} com antecedência.</Typography>
        </S.TextWrapper>
      </S.Container>
    </ModalGeneric>
  )
}